import type { ChunkEntry, RuntimeShim } from './types';

const CHUNK_GLOBAL = 'webpackChunk_N_E';

const registeredShims = new Set<RuntimeShim>();
let interceptorInstalled = false;

const createFanOutPush = (
  array: unknown[],
): ((...items: unknown[]) => number) => {
  return (...items: unknown[]) => {
    const result = Array.prototype.push.apply(array, items);
    for (const item of items) {
      for (const registeredShim of registeredShims) {
        registeredShim.processChunk(item as ChunkEntry);
      }
    }
    return result;
  };
};

export const installChunkInterceptor = (shim: RuntimeShim) => {
  registeredShims.add(shim);

  if (interceptorInstalled) return;
  interceptorInstalled = true;

  const g = globalThis as unknown as Record<string, unknown>;

  const chunkArray: unknown[] = [];
  let activePush = createFanOutPush(chunkArray);

  Object.defineProperty(chunkArray, 'push', {
    get: () => activePush,
    set(fn: (...args: unknown[]) => number) {
      const runtimePush = fn;
      activePush = (...items: unknown[]) => {
        for (const item of items) {
          for (const registeredShim of registeredShims) {
            registeredShim.processChunk(item as ChunkEntry);
          }
        }
        return runtimePush.apply(chunkArray, items);
      };
    },
    configurable: true,
    enumerable: false,
  });

  g[CHUNK_GLOBAL] = chunkArray;
};

export const _resetInterceptorForTests = () => {
  registeredShims.clear();
  interceptorInstalled = false;
  delete (globalThis as unknown as Record<string, unknown>)[CHUNK_GLOBAL];
};
